const Splash = () =>
  import(
    /* webpackChunkName: "site-generator-splash" */ '@/pages/site-generator/cms/splash'
  )
const CreateSplash = () =>
  import(
    /* webpackChunkName: "site-generator-splash" */ '@/pages/site-generator/cms/splash/create.vue'
  )
const EditSplash = () =>
  import(
    /* webpackChunkName: "site-generator-splash" */ '@/pages/site-generator/cms/splash/edit.vue'
  )

export default {
  path: 'splash',
  meta: {
    label: 'splash',
    auth: 'splash'
  },
  component: {
    name: 'Splash',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteSplashReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Splash
    },
    {
      name: 'SiteCreateSplash',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSplash
    },
    {
      name: 'SiteEditSplash',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSplash,
      props: true
    }
  ]
}
